import logo from "../assets/logo/tamworld_logo.png";
import { Link } from "react-router-dom";
import { FaFacebookF, FaInstagram, FaYoutube, FaLinkedin,FaWhatsapp } from "react-icons/fa";
import { useEffect, useState } from "react";

const C = {
  gold: "#f5c518",
  goldD: "#d4a80f",
  dark: "#1a1a2e",
};

const iconStyle = {
  width: 36,
  height: 36,
  borderRadius: "50%",
  background: "rgba(255,255,255,.08)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "#fff",
  fontSize: 16,
  transition: "0.3s",
  cursor: "pointer"
};

const F = {
  display: "'Playfair Display', serif",
  body: "'Plus Jakarta Sans', sans-serif",
};

export default function Footer() {

  const [showScroll, setShowScroll] = useState(false);

useEffect(() => {
  const handleScroll = () => {
    if (window.scrollY > 300) {
      setShowScroll(true);
    } else {
      setShowScroll(false);
    }
  };

  window.addEventListener("scroll", handleScroll);

  return () => {
    window.removeEventListener("scroll", handleScroll);
  };
}, []);

  return (
    <>
      {/* ═══════════ CTA BANNER ═══════════ */}
      <section
        style={{
          background: `linear-gradient(135deg,${C.gold},${C.goldD})`,
          padding: "60px 24px",
          textAlign: "center",
        }}
      >
        <h2
          style={{
            fontFamily: F.display,
            fontSize: "clamp(24px,4.5vw,48px)",
            fontWeight: 900,
            color: C.dark,
            marginBottom: 12,
          }}
        >
          Ready for a Safest Ride?
        </h2>

        <p
          style={{
            fontSize: "16px",
            color: "rgba(26,26,46,.7)",
            marginBottom: 30,
          }}
        >
          Book your cab in seconds. No hidden fees. Book in Advance. Just great rides.
        </p>

        <div style={{ display: "flex", gap: 14, justifyContent: "center", flexWrap: "wrap" }}>
          <a href="/">
            <button
              style={{
                background: C.dark,
                color: C.gold,
                border: "none",
                borderRadius: 50,
                padding: "14px 40px",
                fontWeight: 800,
                cursor: "pointer",
              }}
            >
              🚗 Book Now
            </button>
          </a>

          <a href="tel:+919265407669">
            <button
              style={{
                background: "transparent",
                border: `2px solid ${C.dark}`,
                borderRadius: 50,
                padding: "14px 40px",
                fontWeight: 700,
                cursor: "pointer",
              }}
            >
              📞 Call Us
            </button>
          </a>
        </div>
      </section>

      {/* ═══════════ FOOTER ═══════════ */}
      <footer
        style={{
          background: "#0d1120",
          padding: "52px 24px 28px",
          color: "rgba(255,255,255,.55)",
        }}
      >
        <div style={{ maxWidth: 1100, margin: "0 auto" }}>
          
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit,minmax(180px,1fr))",
              gap: 36,
              marginBottom: 44,
            }}
          >
            
            {/* LOGO + SOCIAL */}
            <div>
              <img src={logo} alt="HaloSorath" style={{ height: 46 }} />
              <p style={{ fontSize: 13, marginTop: 10, lineHeight: 1.8 }}>
                Reliable outstation cab booking with zero commission and verified drivers across India.
              </p>

             <div style={{ display: "flex", gap: 12, marginTop: 16 }}>

 <a
  href="https://www.facebook.com/profile.php?id=61590337595706"
  target="_blank"
  rel="noreferrer"
>
  <div style={iconStyle}>
    <FaFacebookF />
  </div>
</a>

<a
  href="https://www.instagram.com/halosorath/?theme=dark"
  target="_blank"
  rel="noreferrer"
>
  <div style={iconStyle}>
    <FaInstagram />
  </div>
</a>

<a
  href="https://www.youtube.com/@HaloSorath-CabServices"
  target="_blank"
  rel="noreferrer"
>
  <div style={iconStyle}>
    <FaYoutube />
  </div>
</a>


 

</div>
            </div>

            {/* SERVICES */}
            <div>
              <h5 style={{ color: "#fff", marginBottom: 14 }}>Services</h5>
              {[
                "Employee Transport",
                "Corporate Rentals",
                "Outstation Cabs",
                "Airport Transfers",
                "Railway Transfers",
                "Luxury Rentals",
                "One-Way Cabs",
              ].map((s) => (
                <p key={s} style={{ fontSize: 13, marginBottom: 7 }}>{s}</p>
              ))}
            </div>

            {/* POLICIES */}
<div>
  <h5 style={{ color: "#fff", marginBottom: 14 }}>Policies</h5>

  <Link to="/privacy" style={{ display: "block", fontSize: 13, marginBottom: 7, color: "#ccc", textDecoration: "none" }}>
    Privacy Policy
  </Link>

  

  <Link to="/terms" style={{ display: "block", fontSize: 13, marginBottom: 7, color: "#ccc", textDecoration: "none" }}>
    Terms & Conditions
  </Link>

  <Link to="/cancellation" style={{ display: "block", fontSize: 13, marginBottom: 7, color: "#ccc", textDecoration: "none" }}>
    Cancellation Policy
  </Link>
</div>

            {/* CONTACT */}
            <div>
              <h5 style={{ color: "#fff", marginBottom: 14 }}>Contact Us</h5>

              <a href="tel:+919265407669" style={{ display: "block", color: "#ccc" }}>
                📞 +91 92654 07669
              </a>

              <a href="mailto:halosorath@gmail.com" style={{ display: "block", color: "#ccc" }}>
                ✉️ halosorath@gmail.com
              </a>

              <p style={{ fontSize: 13, marginTop: 6 }}>📍 407, The Empire Complex, Vanthli road, Near Petrol Pump, Madhuram, Junagadh - 362015</p>

              <a href="https://wa.me/919265407669" target="_blank" rel="noreferrer">
                <button
                  style={{
                    marginTop: 18,
                    background: `linear-gradient(135deg,${C.gold},${C.goldD})`,
                    color: C.dark,
                    border: "none",
                    borderRadius: 50,
                    padding: "10px 22px",
                    fontSize: 13,
                    fontWeight: 700,
                    cursor: "pointer",
                  }}
                >
                  💬 WhatsApp Us
                </button>
              </a>
            </div>
          </div>

          {/* BOTTOM */}
         <div
  style={{
    borderTop: "1px solid rgba(255,255,255,.08)",
    paddingTop: 22,
    textAlign: "left",
  }}
>
  <p style={{ fontSize: 12, marginBottom: 6 }}>
    © 2025 HaloSorath. All rights reserved.
  </p>

  <p style={{ fontSize: 12, marginBottom: 6 }}>
    Made with ❤️ for Indian Travellers
  </p>

  <p style={{ fontSize: 12 }}>
    Designed & Developed by{" "}
    <span style={{ color: "#f5c518", fontWeight: 600 }}>
      <a
  href="https://khevnatech.com"
  target="_blank"
  rel="noreferrer"
  style={{ color: "#f5c518", fontWeight: 600, textDecoration: "none" }}
>
  Khevnatech
</a>
    </span>
  </p>
</div>


        </div>
      </footer>

      {/* Floating WhatsApp */}
              <a href="https://wa.me/919265407669" target="_blank" rel="noreferrer"
                style={{ position:"fixed", bottom:90, right:18, width:48, height:48, borderRadius:"50%", background:"#25D366", display:"flex", alignItems:"center", justifyContent:"center", boxShadow:"0 8px 24px rgba(0,0,0,.25)", zIndex:999, cursor:"pointer", transition:"all .3s" }}
                onMouseEnter={e=>e.currentTarget.style.transform="scale(1.1)"}
                onMouseLeave={e=>e.currentTarget.style.transform="scale(1)"}>
                <FaWhatsapp size={26} color="#fff" />
              </a>

     {/* Scroll To Top Button */}
{showScroll && (
  <button
    onClick={() => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }}
    style={{
      position: "fixed",
      right: 20,
      bottom: 20,
      width: 52,
      height: 52,
      borderRadius: "50%",
      border: "none",
      background: `linear-gradient(135deg, ${C.gold}, ${C.goldD})`,
      color: C.dark,
      fontSize: 22,
      fontWeight: 800,
      cursor: "pointer",
      boxShadow: "0 8px 24px rgba(0,0,0,.25)",
      zIndex: 9999,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transition: "all 0.3s ease",
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = "scale(1.1)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = "scale(1)";
    }}
  >
    ↑
  </button>
)}
    </>
  );
}